$(document).ready(function() {
    if ($('html').attr('lang') === 'ar') {
      const checkInterval = setInterval(function() {
        var h2Text = $('.wbtxReviews-Slider__SliderHead h2').text();
        if (h2Text) {
          $('.wbtxReviews-Slider__SliderHead h2').text("آراء من عملائنا");
            clearInterval(checkInterval);
        }
    }, 500);

    }
    
});


$(document).ready(function() {
    if ($('html').attr('lang') === 'ar') {
      const checkInterval = setInterval(function() {
        var h2Text = $('.js-remove-wishlist').text();
        if (h2Text) {
          $('.js-remove-wishlist').text("يزيل");
            clearInterval(checkInterval);
        }
    }, 500);

    }
    
});



$(document).ready(function() {
    $(".sidebar-menu-wrapper").click(function(event) {
        if (!$(event.target).closest("ul").length) {
            $(this).toggleClass("sidebar-menu-active"); // Toggle class when clicking outside the <ul>
        }
        event.stopPropagation(); // Prevent event from reaching document
    });

    $(document).click(function() {
        $(".sidebar-menu-wrapper").removeClass("sidebar-menu-active"); // Remove class when clicking outside
    });
});
